const bxfKebabMenu = {
    svg: '<svg style="width:0.75rem; height:1.31rem;" viewBox="0 0 12 21"><path d="M3.75 7.688c1.523 0 2.813 1.289 2.813 2.812a2.826 2.826 0 0 1-2.813 2.813A2.8 2.8 0 0 1 .938 10.5 2.826 2.826 0 0 1 3.75 7.688M.938 3.625A2.826 2.826 0 0 1 3.75.813c1.523 0 2.813 1.289 2.813 2.812A2.826 2.826 0 0 1 3.75 6.438 2.8 2.8 0 0 1 .938 3.625m0 13.75a2.826 2.826 0 0 1 2.812-2.812c1.523 0 2.813 1.289 2.813 2.812a2.826 2.826 0 0 1-2.813 2.813 2.8 2.8 0 0 1-2.812-2.813"/></svg>',
};

export { bxfKebabMenu as default };
